module.exports = __webpack_public_path__ + "img/logo11.ed023f59.png";